"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useESignInterstitialBase = void 0;
const React = __importStar(require("react"));
const features_1 = require("../../../features");
const tracker_1 = require("../../../tracker");
const initializer_1 = require("../../../initializer");
const useESignProcess_hook_1 = require("../../../interstitial/hooks/useESignProcess.hook");
const useDismissInterstitial_hook_1 = require("../../../interstitial/hooks/useDismissInterstitial.hook");
const useESignProcessBase_hook_1 = require("../../../interstitial/hooks/useESignProcessBase.hook");
const PROCESS_TYPE = 'CUS_E_SIGN';
const useESignInterstitialBase = ({ eSignData }) => {
    const { beginESignProcessCall, isBeginESignProcessSuccess, isBeginESignProcessError, beginESignProcessData, getSignedDocUploadStatus, finishESignProcessCall, isFinishESignProcessSuccess, isFinishESignProcessError, } = (0, useESignProcess_hook_1.useESignProcess)();
    const { dismissInterstitialCall, isDismissInterstitialSuccess, isDismissInterstitialError } = (0, useDismissInterstitial_hook_1.useDismissInterstitial)();
    const instanceRef = React.useRef(null);
    const operationProcessIdRef = React.useRef('');
    const [isOpen, setIsOpen] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    React.useEffect(() => {
        return () => {
            stopGettingDocStatus();
        };
    }, []);
    React.useEffect(() => {
        tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_OPEN_MODAL);
    }, []);
    React.useEffect(() => {
        if (isBeginESignProcessSuccess && beginESignProcessData) {
            operationProcessIdRef.current = beginESignProcessData.data.operationProcessId;
            handleGetSignedDocUploadStatus();
        }
    }, [isBeginESignProcessSuccess]);
    React.useEffect(() => {
        if (isFinishESignProcessSuccess) {
            dismissInterstitialCall(features_1.InterstitialsTypes.LEGAL, { operationProcessId: operationProcessIdRef.current });
        }
    }, [isFinishESignProcessSuccess]);
    React.useEffect(() => {
        if (isDismissInterstitialSuccess) {
            setIsOpen(false);
        }
    }, [isDismissInterstitialSuccess]);
    React.useEffect(() => {
        if (isBeginESignProcessError || isFinishESignProcessError || isDismissInterstitialError) {
            setIsError(true);
            setIsLoading(false);
        }
    }, [isBeginESignProcessError, isFinishESignProcessError, isDismissInterstitialError]);
    React.useEffect(() => {
        if (isError) {
            tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_ERROR);
        }
    }, [isError]);
    const handleDocUrlLink = () => {
        tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_DOC_LINK);
        window.open(eSignData.legalData.url);
    };
    const handleWSResponse = (operationProcessStatus) => {
        stopGettingDocStatus();
        if (operationProcessStatus === useESignProcessBase_hook_1.DOC_UPLOADED_SUCCESSFUL) {
            finishESignProcessCall(operationProcessIdRef.current, { visible: true });
        }
        else if (operationProcessStatus === useESignProcessBase_hook_1.DOC_UPLOADED_ERROR) {
            setIsError(true);
        }
    };
    const handleWSError = (error) => {
        console.error(error.message);
        setIsError(true);
        stopGettingDocStatus();
    };
    const handleGetSignedDocUploadStatus = async () => {
        const instance = getSignedDocUploadStatus(operationProcessIdRef.current, handleWSResponse, handleWSError);
        if (instance) {
            instanceRef.current = instance;
            instance?.start();
        }
    };
    const stopGettingDocStatus = () => {
        if (instanceRef.current) {
            instanceRef.current.stop();
            instanceRef.current = null;
            setIsLoading(false);
        }
    };
    const handleAcceptButton = () => {
        if (!isError) {
            if (!(0, features_1.isContactCenter)()) {
                tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_ACCEPT_BUTTON);
                setIsLoading(true);
                beginESignProcessCall({ processType: PROCESS_TYPE });
            }
            else {
                tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_CONTINUE_BUTTON);
                setIsOpen(false);
            }
        }
        else {
            tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_TRY_AGAIN_BUTTON);
            setIsError(false);
        }
    };
    const handleLogOutButton = async () => {
        if (!(0, features_1.isContactCenter)()) {
            tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_LOG_OUT_LINK);
            if (initializer_1.Session.isValid()) {
                await initializer_1.Authenticator.logout();
            }
            location.replace(window.PRIVATE_WEB_LOGOUT_URL);
        }
    };
    const handleCloseButton = () => {
        if ((0, features_1.isContactCenter)()) {
            tracker_1.tracker.track(features_1.ESignTrackingActions.E_SIGN_INTERSTITIAL_CLOSE_BUTTON);
            setIsOpen(false);
        }
    };
    return {
        handleDocUrlLink,
        handleAcceptButton,
        handleLogOutButton,
        handleCloseButton,
        isOpen,
        isLoading,
        isError,
    };
};
exports.useESignInterstitialBase = useESignInterstitialBase;
//# sourceMappingURL=useESignInterstitialBase.hook.js.map